import { isTeamsAppEnabled as isTeamsAppEnabledBase } from '@atlaskit/teams-app-config/is-teams-app-enabled';

export const isTeamsAppEnabled = (): boolean => {
	return isTeamsAppEnabledBase({
		userHasNav4Enabled: true,
		hostProduct: 'confluence',
	});
};
